import { combineReducers } from "redux";
import { ARIA_LIVE_ANNOUNCE, AriaLiveAnnounceAction } from "./actions";
import { AriaLiveState } from "./types";

const message = (
  state: string = "",
  action: AriaLiveAnnounceAction
): string => {
  switch (action.type) {
    case ARIA_LIVE_ANNOUNCE:
      return action.message;
    default:
      return state;
  }
};

export default combineReducers<AriaLiveState>({
  message,
});
